import React from 'react'

class EaseContactInfo extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
          <div>
              United States +1 312 456 1560<br/>
              Europe +44 20 3379 3802<br/>
              Asia +65 6593 5536<br/><br/>
              <a href="mailto:ease@cmegroup.com">EASE@cmegroup.com</a>
          </div>
        );
    }

}

export default EaseContactInfo;